import '@mdi/font/css/materialdesignicons.css'
import '@/stylesheets/Fonts.scss'

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from "@/store";
import {LocaleApi} from "@swagger";
import VueI18n from "vue-i18n";
import Vuetify from "vuetify";
import VueCookie from "vue-cookie";
import {VueMasonryPlugin} from "vue-masonry";
import BasicComponent, {getApiUrl} from "@/global/BasicComponent";

Vue.config.productionTip = false;

Vue.use(Vuetify);



Vue.use(VueCookie);
Vue.use(VueI18n);
Vue.use(VueMasonryPlugin);
Vue.mixin(BasicComponent);

new LocaleApi({
    basePath: getApiUrl(),
}).getMessages()
    .then((data) => {
        document.title = data["PAGE_TITLE"] ?? "Fotobestellung"
        const lang = data["locale"] ?? "de"
        document.documentElement.lang = lang

        const messages = {
            de: data
        };

        const i18n = new VueI18n({
            locale: "de",
            messages
        });

      const vuetify = new Vuetify(
        {
          theme: {
            options: {
              customProperties: true
            },
            themes: {
              light: {
                primary: data["COLOR_PRIMARY"],
                secondary: data["COLOR_SECONDARY"],
                accent: data["COLOR_ACCENT"],
                error: '#FF5252',
                info: '#2196F3',
                success: '#4CAF50',
                warning: '#FFC107'
              }
            }
          }
        }
      );

        var vm = new Vue({
            vuetify,
            router,
            store,
            i18n,
            render: h => h(App)
        }).$mount('#app');

    })
    .catch((err) => {
        if (err.json) err.json().then(error => {
            console.error(error)
        });
        else console.error(err);
    });



